<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Regenerate Fectory API Token</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="alert alert-warning text-center">
                Are you sure you wish to regenerate the API token?
                <strong>This action is not reversible and will invalidate the previous API token.</strong>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-secondary w-100" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
            <div class="col-md-6">
              <div class="btn btn-warning w-100" @click="regen_token()">
                Confirm
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Storage from "../../helpers/storage";

export default {
  name: "FactoryAPITokenRegen",
  props: ["id"],
  data() {
    return {
      ref: "",
    };
  },
  mounted() {
    this.emitter.on("factory_details_loaded", (data) => {
      this.ref = data.ref ? data.ref : "";
    });
  },
  methods: {
    regen_token() {
      var sessionTokens = Storage.get("session_tokens", true),
        axeTokens = Storage.get("tokens");

      axios
        .post(
          process.env.MIX_APP_URL +
            "/api/v1/factories/" +
            this.ref + "/refresh_token",
            {
              
            },
          {
            headers: {
              Authorization:
                sessionTokens.token_type + " " + sessionTokens.access_token,
                "RT-Authorization": axeTokens.access_token,
            },
          }
        )
        .then((response) => {
          if (200 === response.status) {
            this.emitter.emit("factory_api_token_regen", response.data);

            let factoryAPITokenRegenModal = bootstrap.Modal.getInstance(
              document.getElementById(this.id)
            );
            factoryAPITokenRegenModal.hide();

            this.emitter.emit("popup_alert", {
              type: "success",
              text: "Factory API Token successfully regenerated!",
            });
          } else {
            this.emitter.emit("popup_alert", {
              type: "danger",
              text: response.message,
            });
          }
        });
    },
  },
};
</script>